import PostPreview from "@/components/blog/post-preview";

export default function MorePosts({ title, posts }) {
  return (
    <div
      className="elementor-column elementor-col elementor-top-column elementor-element"
      data-id="e713e97"
      data-element_type="column"
    >
      <div className="elementor-widget-wrap elementor-element-populated">
        <div
          className="elementor-element elementor-element-4bcecaf elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
          data-id="4bcecaf"
          data-element_type="widget"
          data-widget_type="divider.default"
        >
          <div className="elementor-widget-container">
            <div className="elementor-divider">
              <span className="elementor-divider-separator"></span>
            </div>
          </div>
        </div>

        <div
          className="elementor-element elementor-element-f6f9ffc elementor-widget elementor-widget-heading"
          data-id="f6f9ffc"
          data-element_type="widget"
          data-widget_type="heading.default"
        >
          <div className="elementor-widget-container">
            <h3 className="elementor-heading-title elementor-size-default">
              {title ? title : "Some More Posts"}
            </h3>
          </div>
        </div>

        <div className="grid gap-10 lg:gap-10 md:grid-cols-2 xl:grid-cols-3 mt-[10%]">
          {posts?.map(({ node }) => (
            <PostPreview
              key={node.slug}
              aspect="square"
              title={node.title}
              coverImage={node.featuredImage}
              date={node.date}
              author={node.author}
              slug={node.slug}
              excerpt={node.excerpt}
              categories={node.categories}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
